import {
  Children,
  cloneElement,
  CSSProperties,
  MutableRefObject,
  ReactElement,
  useRef,
} from "react";
import { useHover } from "usehooks-ts";

export function Hover(props: {
  baseStyle?: CSSProperties;
  hoverStyle?: CSSProperties;
  children: ReactElement<{
    ref: MutableRefObject<HTMLElement | null>;
    hover?: boolean;
    style?: CSSProperties;
  }>;
}) {
  const ref = useRef(null);
  const hover = useHover(ref);
  const child = Children.only(props.children);
  const style: CSSProperties = {
    ...child.props.style,
    ...props.baseStyle,
    ...(hover ? props.hoverStyle : undefined),
  };
  return cloneElement(child, { ...child.props, ref, style });
}
